module.exports = __webpack_public_path__ + "UX6.png?b7bd980e4cdc56279fa7721e4e562357";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX6.png
// module id = 104
// module chunks = 0